import { experimentsReady, trackEvent } from '@jumpcloud/ui-experiments';

export default {
  trackExperimentEvent(eventType, eventValue, properties) {
    const retryCallLimit = 10;
    const retryInterval = 100; // milliseconds based on a fast API response
    let retry = 0;

    const checkSDK = setInterval(() => {
      // In case the SDK is not initialized by the time our created hook fires
      if (experimentsReady()) {
        trackEvent('anonymous', eventType, eventValue, properties);
        clearInterval(checkSDK);
      } else if (retry < retryCallLimit) {
        retry += 1;
      } else {
        clearInterval(checkSDK);
      }
    }, retryInterval);
  },
};
